import { lazy } from 'react';

import Menu from '../components/Menu';

// Preload
const Footer = lazy(() => import(/* webpackChunkName: "footer" */ /* webpackPreload: true */ '../components/Footer'));
const Welcome = lazy(() => import(/* webpackChunkName: "page-welcome" */ /* webpackPreload: true */ './Welcome'));

// Prefetch
const AutoLogin = lazy(() => import(/* webpackChunkName: "autologin" */ /* webpackPrefetch: true */ './AutoLogin'));
const Features = lazy(() => import(/* webpackChunkName: "page-feature" */ /* webpackPrefetch: true */ './Features'));
const ForgotPassword = lazy(() => import(/* webpackChunkName: "page-forgot-password" */ /* webpackPrefetch: true */ './ForgotPassword'));
const Help = lazy(() => import(/* webpackChunkName: "page-help" */ /* webpackPrefetch: true */ './Help'));
const Mobile = lazy(() => import(/* webpackChunkName: "page-mobile" */ /* webpackPrefetch: true */ './Mobile'));
const Pricing = lazy(() => import(/* webpackChunkName: "page-pricing" */ /* webpackPrefetch: true */ './Pricing'));
const Schedule = lazy(() => import(/* webpackChunkName: "page-schedule" */ './Schedule'));
const Signin = lazy(() => import(/* webpackChunkName: "page-signin" */ /* webpackPrefetch: true */ './Signin'));
const Signup = lazy(() => import(/* webpackChunkName: "page-signup" */ /* webpackPrefetch: true */ './Signup'));

// Not bundle optimisation
const ResetPassword = lazy(() => import(/* webpackChunkName: "page-resetpassword" */ './ResetPassword'));
const ValidateResetPassword = lazy(() => import(/* webpackChunkName: "page-validate-password" */ './ValidateResetPassword'));
const Unsubscribe = lazy(() => import(/* webpackChunkName: "page-unsubscribe" */ './Unsubscribe'));

export { AutoLogin, Features, Footer, ForgotPassword, Help, Unsubscribe, Menu, Mobile, Pricing, ResetPassword, Schedule, Signin, Signup, ValidateResetPassword, Welcome };
